<template>
  <el-card
    class="missing-params-card"
    shadow="hover"
    v-if="errors && errors.length"
  >
    <div class="header">
      <el-icon class="icon">
        <i class="el-icon-warning-outline"></i>
      </el-icon>
      <span class="title">The following parameters are missing :</span>
    </div>

    <el-divider></el-divider>

    <div>
      <el-tag
        v-for="(param, index) in errors"
        :key="index"
        type="danger"
        size="medium"
        effect="dark"
        class="tag"
      >
        {{ param }}
      </el-tag>
    </div>
  </el-card>
</template>

<script>
import { postAPICall } from "../../../helpers/httpHelper";

export default {
  name: "MissingParameters",
  data() {
    return {
      errors: [],
    };
  },
  async mounted() {
    await this.checkParams();
  },
  computed: {
    queryParams() {
      return this.$route.query;
    },
  },
  methods: {
    async checkParams() {
      try {
        let required_params = ["company_slug", "target_url", "type"];
        let query_params = this.queryParams;
        required_params.forEach((param) => {
          if (!query_params[param]) {
            this.errors.push(param);
          }
        });
        if (!this.errors.length) {
          let relayState = {
            url: query_params["target_url"],
            slug: query_params["company_slug"],
            type: query_params["type"],
          };
          let result = await this.redirectToIdp(relayState);
          window.open(result, "_self");
        }
      } catch (err) {
        console.log("err", err);
      }
    },
    async redirectToIdp(params) {
      try {
        let response = await postAPICall(
          "POST",
          "/idp/external_idp_routes/redirect-to-idp",
          params
        );
        return response.data;
      } catch (err) {
        console.log("Err", err);
      }
    },
  },
};
</script>

<style scoped>
.missing-params-card {
  max-width: 600px;
  margin: 20px auto;
  border-radius: 12px;
}

.header {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #d9534f;
}

.icon {
  font-size: 20px;
  margin-right: 8px;
}

.tag {
  margin: 4px;
}

.no-missing {
  text-align: center;
  margin-top: 15px;
}
</style>
